require("./contractLoanSuccess.scss");
// @vendor
const React = require("react");
const { withRouter } = require("react-router-dom");
const PropTypes = require("prop-types");
// @core
const { FormattedText, formatText } = require("core/i18n").i18n;
//@utilities
const {
    decimalsLength,
    formatWithoutRound,
    getFormattedString,
} = require("utilities/currencyHelper");
const OKInformativeListItem = require("components/rebrand/OKInformativeListItem/OKInformativeListItem");
const OKInformativeList = require("components/rebrand/OKInformativeList/OKInformativeList");
const WizardSuccess = require("components/commons/wizardSuccess/wizardSuccess");
const {
    findPurposeById,
} = require("../contractPayrollLoan/payrollLoanPurposes");
const { PERCENTAGE_SYMBOL } = require("constants/index");
const { OKMessage } = require("commonsComponents/OKMessage");
const { recordPage, recordLinkV2 } = require("utilities/tagging");
//@analytics
const {
    analyticsId,
    catalogue,
} = require("../contractPayrollLoan/payrollLoanRequest/analytics/payrollLoanRequestAnalytics");

class ContractLoanSuccess extends React.Component {
    componentDidMount() {
        recordLinkV2(
            catalogue[analyticsId.PAYROLL_LOAN_REQUEST_STEP_4_SUCCESS]()
        );
        recordPage(
            catalogue[analyticsId.PAYROLL_LOAN_REQUEST_WIZARD_SUCCESS]()
        );
    }

    buildContent() {
        const { viewToRender, email } = this.props;
        let subTitleText;
        let subMessage;
        let informativeText;

        //build columns items for layout
        const listItems = this.buildList();
        //set up redirection link for right bottom button
        const goToGlobalPosition = {
            label: formatText("contractEasyLoanError-goBackLinkText"),
            url: "/myprofile/global",
        };

        //build just the subtitle if we are in contract-payroll-loan view
        if (viewToRender === "contract-payroll-loan") {
            subTitleText = this.buildSubTitlePayrollLoanContracts();
            informativeText = this.buildInformativeText(email);
        }
        //build a sub message section if we are in payroll-loan-request view
        else if (viewToRender === "contract-payroll-request") {
            subTitleText = this.buildSubTitlePayrollLoanRequest();
            subMessage = this.buildSubMessage();
        }

        return (
            <WizardSuccess
                successMessage={subTitleText}
                successSubMessage={subMessage}
                mainButton={goToGlobalPosition}
                secondaryButtonStyle="link-complementary"
            >
                <div>
                    <div className="contract-payroll-loan-success__col-separator" />
                    <OKInformativeList columns={2}>
                        {listItems}
                    </OKInformativeList>
                    {informativeText}
                </div>
            </WizardSuccess>
        );
    }

    buildInformativeText(email) {
        return (
            <OKMessage type="informative">
                <div>
                    <div>
                        <FormattedText value="contractLoanSuccess-informativeText" />
                        <b>{email}</b>
                        <FormattedText value="contractLoanSuccess-informativeText2" />
                    </div>
                    <div>
                        <FormattedText value="contractLoanSuccess-informativeText3" />
                    </div>
                </div>
            </OKMessage>
        );
    }

    buildList() {
        const { immData, taeTooltip, viewToRender } = this.props;
        let taeItem;
        let loanImportTitle =
            viewToRender === "contract-payroll-loan"
                ? "loanImportContracts"
                : "loanImport";

        const immCollective = immData.getIn(["collectiveInformation", "0"]);
        const isCollective = immData.get("isCollective");
        const tin =
            isCollective && immCollective
                ? immCollective.get("tin")
                : immData.get("tin");
        const tae =
            isCollective && immCollective
                ? immCollective.get("tae")
                : immData.get("tae");

        if (taeTooltip) {
            taeItem = {
                title: formatText("contractEasyLoan-TAE"),
                bodyText: this.formatInterest(tae),
                icon: "icon-informacion",
                tooltipModifier: "dark-bg",
                tooltipPlacement: "top",
                tooltipClassName: "contract-loan-compilation-card__tooltip",
                iconCustomClass: "contract-loan-compilation-card__tae-icon",
                tooltipOffset: [0, -10],
                information: taeTooltip,
            };
        } else {
            taeItem = {
                title: formatText("contractEasyLoan-TAE"),
                bodyText: this.formatInterest(immData.get("tae")),
            };
        }

        const fields = [
            {
                title: formatText(`contractLoanSuccess-${loanImportTitle}`),
                bodyText: getFormattedString({
                    amount: immData.get("selectedAmount"),
                    decimalsLength: 0,
                    currency: immData.get("currency"),
                }),
            },
            {
                title: formatText("contractLoanSuccess-tin"),
                bodyText: this.formatInterest(tin),
            },
            {
                title: formatText("contractEasyLoanSuccess-term"),
                bodyText: formatText("contractEasyLoan-termMonths", [
                    immData.get("selectedTerm"),
                ]),
            },
            {
                title: formatText("contractEasyLoan-monthlyInstallment"),
                bodyText: getFormattedString(immData.get("installment")),
            },
            taeItem,
        ];

        return fields.map((field, index) => {
            return (
                <OKInformativeListItem
                    key={field.title + index}
                    title={field.title}
                    bodyText={field.bodyText}
                    icon={field.icon}
                    iconCustomClass={field.iconCustomClass}
                    information={field.information}
                    tooltipClassName={field.tooltipClassName}
                    tooltipOffset={field.tooltipOffset}
                    tooltipPlacement={field.tooltipPlacement}
                    tooltipModifier={field.tooltipModifier}
                />
            );
        });
    }

    buildSubMessage() {
        return (
            <div className="contract-payroll-loan-success__informative-message">
                <div>
                    <FormattedText value="contractLoanSuccess-informativeMessage" />
                </div>
                <div>
                    <FormattedText value="contractLoanSuccess-informativeMessage2" />
                </div>
                <div>
                    <a
                        href="#"
                        className="contract-payroll-loan-success__link-text"
                        onClick={() => this.handleGoToMorgagePage()}
                    >
                        <FormattedText value="contractLoanSuccess-informativeMessage3" />
                    </a>
                    <FormattedText value="contractLoanSuccess-informativeMessage4" />
                </div>
            </div>
        );
    }

    buildSubTitlePayrollLoanContracts() {
        const { immData, isDragoFeature } = this.props;
        let purposeSucessText;
        if (isDragoFeature) {
            const finalPurpose = immData
                .get("newPurposesList")
                .find(
                    (purposeElement) =>
                        purposeElement.get("id") ===
                        immData.get("selectedPurposeDrago")
                );
            purposeSucessText = finalPurpose.get("text").toLowerCase();
        } else {
            const purposeObject = findPurposeById(
                immData.get("selectedPurpose")
            );
            if (purposeObject && purposeObject.payrollLoanContractsTransKey) {
                purposeSucessText = formatText(
                    purposeObject.payrollLoanContractsTransKey
                );
            }
        }

        return (
            <div className="contract-payroll-loan-success__subtitle--top-space">
                <FormattedText value="contractLoanSuccess-subtitlePayrollLoanContracts" />
                {purposeSucessText}
            </div>
        );
    }

    buildSubTitlePayrollLoanRequest() {
        const { immData, isDragoFeature } = this.props;
        let purposeSucessText;
        if (isDragoFeature) {
            const purposeElement = immData
                .get("newPurposesList")
                .find(
                    (purposeElement) =>
                        purposeElement.get("id") ===
                        immData.get("selectedPurposeDrago")
                );
            purposeSucessText = !!purposeElement
                ? ` ${purposeElement.get("text").toLowerCase()} `
                : "";
        } else {
            const purposeObject = findPurposeById(
                immData.get("selectedPurpose")
            );
            purposeSucessText =
                purposeObject && purposeObject.payrollLoanRequestTransKey
                    ? formatText(purposeObject.payrollLoanRequestTransKey)
                    : "";
        }
        return (
            <div className="contract-payroll-loan-success__subtitle contract-payroll-loan-success__subtitle--top-space">
                <FormattedText value="contractLoanSuccess-subMessage" />
                <span>{purposeSucessText}</span>
                <FormattedText value="contractLoanSuccess-subMessage2" />
            </div>
        );
    }

    formatInterest(interest) {
        return formatWithoutRound(
            interest,
            decimalsLength(interest),
            "es"
        ).concat(" ", PERCENTAGE_SYMBOL);
    }

    handleGoToMorgagePage() {
        this.props.history.push("/myprofile/loans-mortgages");
    }

    builDisclaimerText() {
        return (
            <div className="contract-payroll-loan-success__superscript-info">
                <FormattedText value="contractEasyLoanStepOne-contractEasyLoanStepOne_superscriptInfo" />
            </div>
        );
    }

    render() {
        const content = this.buildContent();
        const disclaimerText = this.builDisclaimerText();

        return (
            <article className="row no-gutter">
                <div className="col-xs-offset-1 col-xs-9">
                    {content}
                    {disclaimerText}
                </div>
            </article>
        );
    }
}

ContractLoanSuccess.propTypes = {
    immData: PropTypes.object.isRequired,
    isDragoFeature: PropTypes.bool,
    taeTooltip: PropTypes.object,
    viewToRender: PropTypes.string.isRequired,
    email: PropTypes.string,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(ContractLoanSuccess);
